
import actionTypes from './actionTypes';
import initialState from './initialState';

const reducer = (state, { type, payload }) => {
    state = state || initialState;
    switch (type) {
        case actionTypes.TOGGLE_CHANGED:
            return {
                ...state,
                isToggled: payload
            };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/modules/account-connector/components/proof-of-ownership-mobile/reducers.js